import axios from 'axios'
import router from './router/CareRingsRouter.js'
import store from './store/index.js'
const http = axios.create({
  // for cors
  withCredentials: true
})
http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // 認証エラー時の処理
    if (error.response.status) {
      if (error.response.status === 401) {
        if (location.pathname.match('/master')) {
          router.push('/Master/Pages')
          store.dispatch('systemAdminDefine/successLogoutFlag')
          store.dispatch('systemAdminDefine/changeUnauthorizedFlag')
        } else {
          router.push('/Pages')
          store.dispatch('masters/successLogoutFlag')
          store.dispatch('masters/changeUnauthorizedFlag')
        }
        // システムエラー時の処理
      }
    }
    return Promise.reject(error)
  }
)

export default Vue => {
  Vue.http = http
  Object.defineProperties(Vue.prototype, {
    $http: {
      get() {
        return http
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/http.js